import { CtaButton, MaskedLines, Overline, Reveal, Section } from "./ui";
import { scrollToId } from "@/lib/scroll";

export default function Final() {
  return (
    <>
      <Section tone="black" className="relative overflow-hidden">
        <div className="pointer-events-none absolute left-1/2 top-10 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-mom-vinho/20 blur-3xl" />
        <div className="relative text-center">
          <Overline>Agora</Overline>
          <MaskedLines
            inView
            as="h2"
            className="mx-auto mt-5 max-w-3xl font-serif text-3xl font-medium leading-[1.12] tracking-tight sm:text-4xl lg:text-6xl"
            lines={["O futuro do seu salão", "está acontecendo agora"]}
          />
          <Reveal delay={0.15} className="mx-auto mt-12 max-w-xl space-y-2.5 font-serif text-lg font-normal text-white/80 sm:text-xl">
            <p>No horário que abriu.</p>
            <p>Na cliente que ainda pode voltar.</p>
            <p>Na parceria que ainda pode começar.</p>
            <p className="text-mom-carmim">Na decisão que continua sendo adiada.</p>
          </Reveal>
          <Reveal delay={0.25} className="mx-auto mt-10 max-w-xl font-dmsans text-sm leading-relaxed text-white/50 sm:text-base">
            <p>
              O futuro do salão também é construído nas decisões pequenas do
              presente: horários vazios, clientes sem acompanhamento e decisões
              adiadas constroem o que o negócio se torna depois.
            </p>
          </Reveal>
        </div>
      </Section>

      <section className="relative overflow-hidden bg-[radial-gradient(circle_at_50%_20%,#C11B3E,#A91532_55%,#8A0F27)] text-white">
        <div className="mx-auto w-full max-w-6xl px-6 py-24 text-center sm:px-10 lg:py-32">
          <MaskedLines
            inView
            as="h2"
            className="mx-auto max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl"
            lines={["Não sabe o que fazer", <em key="a" className="italic">agora?</em>]}
          />
          <Reveal delay={0.15}>
            <p className="mt-6 font-serif text-2xl font-medium sm:text-3xl">Pergunta pro MOM.</p>
            <p className="mt-3 font-dmsans text-sm text-white/75">Uma situação. Uma missão.</p>
          </Reveal>
          <Reveal delay={0.25} className="mt-10">
            <CtaButton testId="final-cta" variant="white" onClick={() => scrollToId("#oferta")}>
              Começar agora
            </CtaButton>
          </Reveal>
          <Reveal delay={0.35}>
            <p className="mt-12 font-dmsans text-[10px] font-medium uppercase tracking-[0.28em] text-white/60">
              A próxima decisão do seu salão
            </p>
          </Reveal>
        </div>
      </section>

      <footer className="bg-mom-cream text-hc-ink">
        <div className="mx-auto w-full max-w-6xl px-6 py-16 sm:px-10">
          <div className="flex flex-col gap-10 border-b border-black/10 pb-12 lg:flex-row lg:justify-between">
            <div className="max-w-xs">
              <p className="font-dmsans text-xl font-bold tracking-[0.08em]">MOM</p>
              <p className="mt-4 font-dmsans text-sm leading-relaxed text-hc-mutedInk">
                Uma situação. Uma missão. A próxima decisão do seu salão, sem
                planner e sem vinte opções para escolher.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
              <div>
                <p className="font-dmsans text-[11px] font-semibold uppercase tracking-[0.2em] text-hc-mutedInk">Produto</p>
                <ul className="mt-4 space-y-2.5 font-dmsans text-sm text-hc-mutedInk">
                  <li>Funcionalidades</li>
                  <li>Como funciona</li>
                  <li>Planos</li>
                </ul>
              </div>
              <div>
                <p className="font-dmsans text-[11px] font-semibold uppercase tracking-[0.2em] text-hc-mutedInk">Suporte</p>
                <ul className="mt-4 space-y-2.5 font-dmsans text-sm text-hc-mutedInk">
                  <li>Dúvidas frequentes</li>
                  <li>Garantia de 7 dias</li>
                </ul>
              </div>
              <div>
                <p className="font-dmsans text-[11px] font-semibold uppercase tracking-[0.2em] text-hc-mutedInk">Ecossistema</p>
                <p className="mt-4 font-dmsans text-sm font-semibold uppercase tracking-[0.14em] text-mom-vinho">
                  by SalonUP
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 pt-8 font-dmsans text-xs text-hc-mutedInk sm:flex-row sm:items-center sm:justify-between">
            <p>© 2026 MOM · Todos os direitos reservados.</p>
            <p>Página de demonstração · Preços e condições ilustrativos.</p>
          </div>
        </div>
      </footer>
    </>
  );
}
